export const ham_anxiety = {
    "slug": "ham_anxiety",
    "maxScore": 56,
    "threshold": 25,
    "scoreUnitKey": "Points",
    "totalQuestions": 14,
    "estimatedTimeMinutes": 3,
    "translations": {
        "name": {
            "en": "Anxiety",
            "bg": "Тревожност"
        },
        "description": {
            "en": "What it does: This test measures the severity of anxiety symptoms—both physical (like restlessness or tension) and psychological (like excessive worry or fear).\nWhy take it: It’s helpful if you’ve been feeling unusually anxious, nervous, or overwhelmed, and want to understand the intensity of your symptoms.",
            "bg": "Какво прави този тест: Този тест измерва тежестта на симптомите на тревожност – както физически (като неспокойствие или напрежение), така и психологически (като прекомерно безпокойство или страх).\nЗащо да го направите: Полезен е, ако се чувствате необичайно тревожни, нервни или претоварени и искате да разберете колко интензивни са вашите симптоми."
        },
        "results": {
            "mild": {
                "en": "Your anxiety level is mild. Your symptoms are within a manageable range, but it’s still helpful to practice self-care and monitor your stress.",
                "bg": "Нивото ви на тревожност е леко. Симптомите ви са в управляеми граници, но все пак е добре да практикувате самоподдръжка и да следите нивата на стрес."
            },
            "mild_moderate": {
                "en": "Your anxiety level is mild to moderate. You may be experiencing some impact on daily life — consider stress management strategies or seeking support if needed.",
                "bg": "Нивото ви на тревожност е от леко до умерено. Може да има известен ефект върху ежедневието — помислете за стратегии за справяне със стреса или потърсете подкрепа при нужда."
            },
            "moderate_severe": {
                "en": "Your anxiety level is moderate to severe. The symptoms may significantly affect your functioning. A mental health professional can help you explore coping tools.",
                "bg": "Нивото ви на тревожност е от умерено до тежко. Симптомите може съществено да влияят върху функционирането ви. Професионалист по психично здраве може да ви помогне с подходящи инструменти."
            },
            "severe": {
                "en": "Your anxiety level is severe. This level of anxiety can be debilitating and should be addressed with professional help as soon as possible.",
                "bg": "Нивото ви на тревожност е тежко. То може да бъде изтощително и е добре да потърсите професионална помощ възможно най-скоро."
            }
        }
    },
    "resultsSection": {
        "didYouKnow": {
            "en": "Anxiety is not just 'in your head'—it triggers physical responses in the nervous system. According to the WHO, anxiety disorders are the most common mental health conditions worldwide, affecting over 300 million people.",
            "bg": "Тревожността не е просто „в главата ви“ — тя активира физически реакции в цялата нервна система. Според СЗО, тревожните разстройства са най-често срещаните състояния на психичното здраве в света, засягащи над 300 милиона души."
        },
        "faqs": [
            {
                "question": {
                    "en": "Why does anxiety cause physical symptoms like fast heartbeat or tension?",
                    "bg": "Защо тревожността причинява физически симптоми като ускорен пулс или напрежение?"
                },
                "answer": {
                    "en": "Anxiety activates your sympathetic nervous system (the 'fight-or-flight' response), releasing adrenaline. This increases heart rate, tightens muscles, and alters breathing—even when there is no actual physical danger.",
                    "bg": "Тревожността активира симпатиковата нервна система (реакцията „борба или бягство“), освобождавайки адреналин. Това ускорява пулса, стяга мускулите и променя дишането — дори когато няма реална физическа опасност."
                }
            },
            {
                "question": {
                    "en": "What is the difference between normal stress and an anxiety disorder?",
                    "bg": "Каква е разликата между нормалния стрес и тревожното разстройство?"
                },
                "answer": {
                    "en": "Stress is typically a temporary reaction to an external trigger (like a deadline). Anxiety tends to persist even after the stressor is gone, causing excessive, hard-to-control worry and functional friction in daily life.",
                    "bg": "Стресът обикновено е временна реакция на външен дразнител (като краен срок). Тревожността проявява тенденция да продължава и след като стресорът го няма, причинявайки прекомерно, трудно за контролиране безпокойство."
                }
            },
            {
                "question": {
                    "en": "How can Cognitive Behavioral Therapy (CBT) help with anxiety?",
                    "bg": "Как когнитивно-поведенческата терапия (КПТ) помага при тревожност?"
                },
                "answer": {
                    "en": "CBT helps you identify automatic negative thoughts and catastrophic thinking patterns. By restructuring these thoughts and practicing gradual exposure, you retrain your brain to respond to stress with resilience.",
                    "bg": "КПТ ви помага да идентифицирате автоматичните негативни мисли и катастрофичните мисловни модели. Чрез преструктуриране на тези мисли, вие тренирате мозъка си да реагира на стреса с по-голяма устойчивост."
                }
            }
        ]
    },
    "answerOptions": [
        { "value": 0, "translations": { "en": "Absent", "bg": "Липсва" } },
        { "value": 1, "translations": { "en": "Mild", "bg": "Леко" } },
        { "value": 2, "translations": { "en": "Moderate", "bg": "Средно" } },
        { "value": 3, "translations": { "en": "Severe", "bg": "Силно" } },
        { "value": 4, "translations": { "en": "Very severe", "bg": "Много силно" } }
    ],
    "questions": [
        {
            "order": 1,
            "translations": {
                "en": "Anxious mood. The client experiences worries, fears, anticipation of the worst, irritability.",
                "bg": "Тревожно настроение. Изпитвате притеснения, страхове, очакване за най-лошото, раздразнителност."
            }
        },
        {
            "order": 2,
            "translations": {
                "en": "Tension. Feelings of nervousness, easy fatigue, startle response to noise or distressing news, frequent crying, trembling (body, foot tapping, shaking hands), inability to stay still or rest.",
                "bg": "Напрежение. Чувства за напрегнатост, лесна уморяемост, лесно стряскане при шум или чута обезпокоителна новина, лесно разплакване, треперене (тяло, потропване с крака, треперещи ръце), невъзможност да се стои на едно място или да се почива."
            }
        },
        {
            "order": 3,
            "translations": {
                "en": "Fears. Fear of the dark, strangers, being alone, animals, traffic, crowds.",
                "bg": "Страхове. От тъмното, от непознати, от оставане сам, от животни, трафик, тълпи хора."
            }
        },
        {
            "order": 4,
            "translations": {
                "en": "Insomnia. Difficulty falling asleep, maintaining sleep, or early waking, light sleep, morning fatigue, and nightmares.",
                "bg": "Инсомния. Трудно заспиване, поддържане на съня или рано будене, повърхностен сън, умора при събуждане и кошмари."
            }
        },
        {
            "order": 5,
            "translations": {
                "en": "Intellectual problems. Difficulty concentrating, poor memory.",
                "bg": "Интелектуални проблеми. Трудности с концентрацията, лоша памет."
            }
        },
        {
            "order": 6,
            "translations": {
                "en": "Depressed mood. Loss of general interest, loss of pleasure in hobbies, depression, early waking, bad mood in the morning that improves during the day or vice versa.",
                "bg": "Депресирано настроение. Загуба на общ интерес, загуба на удоволствие в изпълнение на хобита, депресия, ранно събуждане, лошо настроение сутрин, което през деня чувствително се оправя или обратното."
            }
        },
        {
            "order": 7,
            "translations": {
                "en": "Somatization (bodily sensations). Pain, stiffness, tense muscles, teeth grinding (sometimes unnoticed or unremembered at night but causes broken fillings or tooth damage), timid voice.",
                "bg": "Соматизация (телесни усещания). Болки, схващания, стегната мускулатура, скърцане със зъби (понякога не се познава или човекът не помни през нощта, но например често си чупи пломбите и си наранява зъбите), плах глас."
            }
        },
        {
            "order": 8,
            "translations": {
                "en": "Somatization (perceptions). Tinnitus (ringing in the ears), blurred vision, hot and cold flashes, feelings of weakness, numbness in limbs, or tingling sensations.",
                "bg": "Соматизация (на възприятията). Тинитус (шум в ушите), замъглено виждане, топли и студени вълни, усещане за слабост, изтръпване на крайници или усещания за мравучкане."
            }
        },
        {
            "order": 9,
            "translations": {
                "en": "Cardiac problems. Tachycardia (rapid heartbeat), extrasystoles (heart palpitations), chest pain or heaviness, blood vessel constriction, feeling of impending fainting.",
                "bg": "Сърдечни проблеми. Тахикардия (учестен пулс), екстрасистоли (прескачания на сърцето), болка или тежест в сърдечната област, свиване на кръвоносните съдове, усещане за припадане всеки момент."
            }
        },
        {
            "order": 10,
            "translations": {
                "en": "Respiratory problems. Chest tension, feeling of suffocation, loud breathing on inhalation or exhalation, inability to breathe.",
                "bg": "Дихателни проблеми. Напрежение в гръдния кош, чувство за задушаване, чуване (шумно) на дъха при вдишване или издишване, невъзможност за дишане."
            }
        },
        {
            "order": 11,
            "translations": {
                "en": "Gastrointestinal problems. Difficulty swallowing, stomach pain, heartburn, stomach heaviness, nausea, vomiting, diarrhea, constipation, weight loss.",
                "bg": "Стомашни проблеми. Трудност при преглъщане, стомашни болки, киселини, тежест в стомаха, повдигане, повръщане, диария, запек, загуба на тегло."
            }
        },
        {
            "order": 12,
            "translations": {
                "en": "Sexual or gynecological problems. Frequent urination, inability to retain urine, irregular menstrual cycle, frigidity, premature ejaculation or inability to ejaculate, low libido, unstable erection, impotence.",
                "bg": "Сексуални или гинекологични проблеми. Често уриниране, невъзможност за задържане на урината, нарушен менструален цикъл, фригидност, преждевременна еякулация или невъзможност за еякулация, ниско либидо, нестабилна ерекция, импотентност."
            }
        },
        {
            "order": 13,
            "translations": {
                "en": "Autonomic symptoms. Dry mouth, blushing, rashes, excessive sweating, dizziness, vertigo, tension headaches, hair standing on end.",
                "bg": "Автономни симптоми. Суха уста, изчервяване, обриви, обилно потене, замайване, виене на свят, вертиго, тенсионно главоболие, изправяне на косата или космите по тялото."
            }
        },
        {
            "order": 14,
            "translations": {
                "en": "Behavior during the interview. Restless movement of hands, legs, and body, limb tremors, tense facial expression, rapid breathing, frequent swallowing, facial rashes.",
                "bg": "Поведение по време на интервюто. Неспокойно местене на ръце, крака и тяло, тремор на крайници, напрегнато лице, учестено дишане, често преглъщане, обриви по лицето."
            }
        }
    ]
}